module.exports = __webpack_public_path__ + "img/clubicon-cupcake.8ae899b2.png";